module.exports = __webpack_public_path__ + "img/josh-smile.cfb5554c.jpg";